import React from "react";
import { Text } from "@fluentui/react";
import "./InfoPanelTable.css";

import { sanitizeHtml } from "../../../utils/htmlSanitizer";

export const InfoPanelInformation = ({ data }) => {
    const sastoken = sessionStorage.getItem("SasTokenKey") || "";
    const ServiceHasImage = data?.CommonFields?.ServiceHasImage;
    const ImagePath = data?.CommonFields?.ImagePath;
    return (
        <>
        <div className="tableContainer">
            <table>
                <thead className="tableHeader">
                    <tr>
                        <th className="tableheading">
                            <Text variant="xLarge" block style={{ color: "white", fontSize: '14px' }} className="serviceGroupText">
                                Service Groups
                            </Text>
                        </th>
                        <th className="tableheading">
                            <Text variant="xLarge" block style={{ color: "white", fontSize: '14px' }} className="serviceGroupText requestTypeHeader">
                                Request Types
                            </Text>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <div className="tableSpacer"></div>
                    {Object?.keys(data)?.filter(serviceGroup => serviceGroup !== "CommonFields")?.map((serviceGroup, index) => (
                        <React.Fragment key={serviceGroup}>
                            <tr className="linebreak">
                                <td className="tableCell">
                                    <div className="tableRowSpace">
                                        <Text variant="xLarge" block className="serviceGroupText">
                                            {serviceGroup}
                                        </Text>
                                        <div
                                            className="serviceGroupDescriptionText"
                                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(data[serviceGroup].ServiceGroupDescription , "info-panel-information-html")}}
                                        ></div>
                                    </div>
                                </td>
                                <td>
                                    <div className="tableRowSpace">
                                        <ul >
                                            {data[serviceGroup]?.RequestTypeName?.map((requestType, idx) => (
                                                <li key={requestType}>
                                                    <Text variant="medium" className="requestTypeText">
                                                        {requestType}
                                                    </Text>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                    <div className="tableSpacer"></div>
                </tbody>
            </table>
        </div>
        <div>
            {
                ServiceHasImage && ImagePath && ImagePath !== "" ?
                    <img src={process.env.REACT_APP_BLOBSASSTART + ImagePath + sastoken} alt="Service Image" className="serviceImage" />
                    : null
            }
        </div>

        </>
    );
};

// Generated by Copilot
// updated on: 2026-07-27 | 04 lines added/updated | [Auto Generated] | US 1280933 AC-3 (#12996): sanitize info panel information HTML via shared sanitizeHtml | Time Taken 2 min
